import { __assign, __rest } from "tslib";
import classNames from 'classnames';
import * as React from 'react';
import { CnEllipsis } from '@/components/cn-ellipsis';
export var DefaultFormat = function (props) {
    var column = props.column, rowIndex = props.rowIndex, mode = props.mode, data = props.data;
    var dataIndex = column.dataIndex, getCellProps = column.getCellProps, cell = column.cell;
    var value = dataIndex && data[dataIndex] ? data[dataIndex] : undefined;
    var _a = (getCellProps === null || getCellProps === void 0 ? void 0 : getCellProps(dataIndex ? data[dataIndex] : undefined, data, rowIndex)) ||
        {}, onClickProps = _a.onClick, cellProps = __rest(_a, ["onClick"]);
    var onClick = function (event) {
        if (!onClickProps)
            return;
        onClickProps(event);
        if (mode === 'simple')
            event.stopPropagation();
    };
    if (cell && typeof cell === 'function') {
        return (React.createElement("span", __assign({}, cellProps, { onClick: onClick }), (cell === null || cell === void 0 ? void 0 : cell(value, rowIndex, data)) || '- -'));
    }
    if (!dataIndex)
        return React.createElement(React.Fragment, null, "- -");
    if (value && typeof value === 'object') {
        var _value = value.value, text = value.text, link_1 = value.link, toolTips = value.toolTips, rest = __rest(value, ["value", "text", "link", "toolTips"]);
        var style = {
            color: rest.color,
        };
        var content = (_value !== null && _value !== void 0 ? _value : text) || '- -';
        if (mode === 'simple') {
            return React.createElement(CnEllipsis, { style: style }, content);
        }
        return (React.createElement("span", { className: classNames({ 'cn-table-format-text-link': !!link_1 }), style: style, onClick: function () { return link_1 && window.open(link_1); } }, content));
    }
    if (mode === 'simple' && value) {
        return React.createElement(CnEllipsis, null, value);
    }
    return (React.createElement("span", __assign({}, cellProps, { onClick: onClick }), value || '- -'));
};
